export const PinataPayTransactionResult = {
  Approval: 'approval',
  Decline: 'decline',
  PartialApproval: 'partial_approval',
  ProcessingError: 'processing_error',
  Invalid: 'invalid',
  Cancelled: 'cancelled',
  RefundFailure: 'refund_failure',
  Delayed: 'delayed',
} as const;

export type PinataPayTransactionResult =
  (typeof PinataPayTransactionResult)[keyof typeof PinataPayTransactionResult];
